import { render, staticRenderFns } from "./WordsFieldReadingEn.vue?vue&type=template&id=20a69660&lang=pug&"
import script from "./WordsFieldReadingEn.vue?vue&type=script&lang=js&"
export * from "./WordsFieldReadingEn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports